import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CustomerInternetSpeed from '../../Partials/CustomerInternetSpeed/CustomerInternetSpeed';
import { reportDWH } from '../../AddonsBlockSlice';
import { createWorkOrderAsync, createWhatsAppCallAsync } from '../../AddonsBlockAsyncThunk';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import { buildUrlAndOpenWindow, buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import { gtag4 } from '../../../../../utilities/analytics/tracking';

const ErrorPage = (props) => {

    useEffect(() => {
        switch (props.errorDescription) {
            case 'NO_SUBSCRIBER_ERROR':
                gtag4({ event: `Addon_${props.flowType}_Step1_NoInternetProductsPage`, step: '1', action: 'NoInternetProductsPage', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'SERVICE_EXISTS_ERROR':
                props.reportDWH({ actionType: 'Service Exists Message', status: 'Service Needed', messageText: 'Service Exists Message Displayed' });
                gtag4({ event: `Addon_${props.flowType}_Step2_AddonAlreadyExistPage`, step: '2', action: 'AddonAlreadyExistPage', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'EXISTS_ORDER_ERROR':
                props.reportDWH({ actionType: 'Open Order Exists Message', status: 'Service Needed', messageText: 'Open Order Exists Message Displayed' });
                gtag4({ event: `Addon_${props.flowType}_Step2_AddonOpenOrderPage`, step: '2', action: 'AddonOpenOrderPage', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'NOT_JET_CUSTOMER_ERROR':
                props.reportDWH({ actionType: 'Not JET Customer Message', status: 'Service Needed', messageText: 'Not JET Customer Message Displayed' });
                gtag4({ event: `Addon_${props.flowType}_Step2_CusNotAppearOnJetPage`, step: '2', action: 'CusNotAppearOnJetPage', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'PAYMENT_OR_DEBT_ERROR':
                props.reportDWH({ actionType: 'Finance Message', status: 'Service Needed', messageText: 'Finance Message Page Displayed' });
                gtag4({ event: `Addon_${props.flowType}_Step2_FinProblemPage`, step: '2', action: 'FinProblemPage', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'SERVICE_NOT_SUPPORTED_ERROR':
                props.reportDWH({ actionType: 'Service doesnt Supported Message', status: 'Service Needed', messageText: 'Service doesnt Supported Message Displayed' });
                gtag4({ event: `Addon_${props.flowType}_Step2_AddonNotSupportedPage`, step: '2', action: 'AddonNotSupportedPage', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'NO_INTERNET_SPEED_ERROR':
                props.reportDWH({ actionType: 'Max Speed Message', status: 'Completed', messageText: 'Max Speed Message Displayed' });
                gtag4({ event: `Addon_${props.flowType}_Step2_MaxSpeedPage`, step: '2', action: 'MaxSpeedPage', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'CREATE_SALE_ERROR':
                switch (props.flowType) {
                    case 'service':
                        props.reportDWH({ actionType: 'Purchase Service', status: 'Error', messageText: 'General Error' });
                        if (props.isWhatsAppActive) {
                            props.reportDWH({ actionType: 'Redirect to Service Message', status: 'Service Needed', messageText: 'Redirect to Whatsapp Message Displayed' });
                        }
                        else {
                            props.reportDWH({ actionType: 'Redirect to Service Message', status: 'Service Needed', messageText: 'Redirect to Service Message Displayed' });
                        }
                        break;
                    case 'mesh':
                        props.reportDWH({ actionType: 'Order MESH', status: 'Error', messageText: 'General Error' });
                        if (props.isWhatsAppActive) {
                            props.reportDWH({ actionType: 'Redirect to Service Message', status: 'Service Needed', messageText: 'Redirect to Whatsapp Message Displayed' });
                        }
                        else {
                            props.reportDWH({ actionType: 'Redirect to Service Message', status: 'Service Needed', messageText: 'Redirect to Service Message Displayed' });
                        }
                        break;
                    case 'internetSpeed':
                        props.reportDWH({ actionType: 'Upgrade Speed', status: 'Error', messageText: 'General Error' });
                        if (props.isWhatsAppActive) {
                            props.reportDWH({ actionType: 'Redirect to Upgrade Service Message', status: 'Service Needed', messageText: 'Redirect to Upgrade Whatsapp Message Displayed' });
                        }
                        else {
                            props.reportDWH({ actionType: 'Redirect to Upgrade Service Message', status: 'Service Needed', messageText: 'Redirect to Upgrade Service Message Displayed' });
                        }
                        break;
                }

                if (props.isWhatsAppActive) {
                    gtag4({ event: `Addon_${props.flowType}_Step3_FailurePageGeneral`, step: '3', action: 'FailurePageGeneral', funnel_name: `Addon_${props.flowType}` });
                }
                else {
                    gtag4({ event: `Addon_${props.flowType}_Step3_FailurePageHoraatAvoda`, step: '3', action: 'FailurePageHoraatAvoda', funnel_name: `Addon_${props.flowType}` });
                }
                break;
        }
    }, []);

    let title = null;
    let subTitle = null;
    let icon = 'error-icon';
    let isDisplayContact = false;
    let isDisplayWhatsAppIcon = false;
    let handleOnContinue = handleGoToLobby;
    let btnText = 'חזרה לאיזור האישי';

    switch (props.errorPage) {
        case 'NO_SUBSCRIBER_PAGE':
            title = <> אנחנו לא מזהים שיש לך שירות אינטרנט ב{window.Config.brand_Name_HE} </>;
            subTitle = <> יכול להיות שנרשמת עם פרטים אחרים? שווה לנסות להתחבר שוב </>;
            break;
        case 'SERVICE_EXISTS_PAGE':
            title = <>מסתבר שהשירות כבר קיים לך</>;
            if(props.addon.ipAddress){
                subTitle = <> כתובת ה-IP הקבועה שלך היא <span className='bold-text'>{props.addon.ipAddress}</span></>;
            }
            isDisplayContact = true;
            break;
        case 'NO_INTERNET_SPEED_PAGE':
            title = <> איזה כיף! <br /> אתה על המהירות המקסימלית </>;
            icon = 'success-icon';
            break;
        case 'EXISTS_ORDER_PAGE':
            title = <> מסתבר שכבר יש לך <br /> הזמנה פתוחה </>;
            icon = 'exists-order-icon';
            isDisplayContact = true;
            break;
        case 'PAYMENT_OR_DEBT_PAGE':
            title = <> רק רגע, כרגע לא אפשרי להשלים את הפעולה </>;
            subTitle = <> לפני שנמשיך בתהליך, עליך לעדכן את אמצעי התשלום שלך ב{window.Config.brand_Name_HE} ולשלם את החוב </>;
            break;
        case 'SERVICE_NOT_SUPPORTED_PAGE':
            title = <> נראה שהשירות לא נתמך <br /> בחבילה שלך </>;
            isDisplayContact = true;
            break;
        case 'GENERAL_ERROR_PAGE':
            title = <> כרגע לא אפשרי להשלים את הפעולה </>;
            isDisplayContact = true;
            break;
        case 'WORK_ORDER_PAGE':
            title = <> מעולה, נשאר לסגור כמה פרטים להשלמת ההזמנה </>;
            subTitle = <> ניצור איתך קשר בהקדם האפשרי </>;
            icon = 'work-order-icon';
            break;
        case 'WHATSAPP_PAGE':
            title = <> מעולה, נשאר לסגור כמה פרטים להשלמת ההזמנה </>;
            subTitle = <> נמשיך מכאן לשירות אישי ב- WhatsApp </>;
            icon = 'whatsapp-icon';
            handleOnContinue = handleCreateWhatsAppCall;
            btnText = 'לנציג אנושי ב-WhatsApp';
            isDisplayWhatsAppIcon = true;
            break;
    }


    return (
        <div className='error-page' data-error={props.errorDescription}>

            {
                props.errorPage == 'SERVICE_EXISTS_PAGE' ? (
                    <div className='service-icon'>
                        <Image src={Config.epiBaseUrl + props.addon.cmsData?.imageAddonSelfCare} alt={props.addon.cmsData?.productNameSelfCare} />
                    </div>
                ) : (
                    <div className={icon}>
                        <Image  className="inner-icon" src={require(`./images/${icon}.svg`)} />
                    </div>
                )
            }


            {title && <div className='page-title'> {title} </div>}
            {subTitle && <div className='page-sub-title'> {subTitle} </div>}

            {
                props.errorPage == 'NO_INTERNET_SPEED_PAGE' &&
                <CustomerInternetSpeed downloadSpeed={props.customerSpeed.downloadSpeed} uploadSpeed={props.customerSpeed.uploadSpeed} cssClass='inside-error-page' />
            }

            {
                props.errorPage == 'PAYMENT_OR_DEBT_PAGE' && props.debtPaymentLink && props.hasDebt &&
                <div className='link-wrapper'>
                    <a href='#' onClick={(e) => { handleClickOnLink(e, props.debtPaymentLink, 'hasDebt') }}>לתשלום חוב</a>
                </div>
            }

            {
                props.errorPage == 'PAYMENT_OR_DEBT_PAGE' && props.updatePaymentLink && props.hasPaymentMethodIssue &&
                <div className='link-wrapper'>
                    <a href='#' onClick={(e) => { handleClickOnLink(e, props.updatePaymentLink, 'hasPaymentMethodIssue') }}>לעדכון אמצעי תשלום</a>
                </div>
            }

            {
                props.errorPage == 'NO_SUBSCRIBER_PAGE' && props.joinServiceLink &&
                <div className='link-wrapper'>
                    <a href='#' onClick={(e) => { handleClickOnLink(e, props.joinServiceLink, 'joinService') }}>לחצו כאן להצטרפות לשירות</a>
                </div>
            }

            {
                isDisplayContact &&
                <div className='contact-wrapper'>
                    <div className='contact-title'> נשמח לסייע לך </div>
                    <div className='links-wrapper'>
                        <div className='contact-link whatsapp'> <a href='#' onClick={(e) => handleOpenWhatsApp(e)}> לנציג שירות ב-WhatsApp </a> </div>
                        {/* <div className='contact-link call-to-service'> <a href={`tel:${Config.technicalSupportPhone}`} onClick={handleCallToService}> חייגו <span style={{ direction: 'ltr' }}>&nbsp;{Config.technicalSupportPhone}&nbsp;</span> לנציג שירות </a> </div> */}
                    </div>
                </div>
            }

            {
                props.errorPage == 'WORK_ORDER_PAGE' &&
                <div className='contact-text'>
                    אפשר גם ליצור איתנו קשר <br /> <a href={`tel:${window.Config.technicalSupportPhone}`}> <span style={{ direction: 'ltr' }}>&nbsp;{window.Config.technicalSupportPhone}&nbsp;</span> </a> לנציג שירות
                </div>
            }

            <div className='button-wrapper'>
                <BtnSubmit
                    //className='btn-submit-white'
                    isBusiness={false}
                    text={btnText}
                    onclick={handleOnContinue}
                    formid='error-page'
                    isDisplayArrows={false}
                    isDisplayWhatsAppIcon={isDisplayWhatsAppIcon}
                />
                {
                    props.errorPage == 'WHATSAPP_PAGE' &&
                    <div className='whatsapp-link-wrapper'>
                        <a href='#' onClick={(e) => handleLeadFormClick(e)}>שנציג יחזור אלי</a>
                    </div>
                }
            </div>

        </div>
    );

    function handleClickOnLink(e, url, actionName) {
        e.preventDefault();
        switch (props.errorDescription) {
            case 'PAYMENT_OR_DEBT_ERROR':
                props.reportDWH({ actionType: 'Finance Message', status: 'Ongoing', messageText: 'Finance Message Page Button Clicked' });
                if (actionName == 'hasDebt') {
                    gtag4({ event: `Addon_${props.flowType}_Step2_FinProblemDebtPaymentButton`, step: '2', action: 'FinProblemDebtPaymentButton', funnel_name: `Addon_${props.flowType}` });
                }
                if (actionName == 'hasPaymentMethodIssue') {
                    gtag4({ event: `Addon_${props.flowType}_Step2_FinProblemPaymentMethodButton`, step: '2', action: 'FinProblemPaymentMethodButton', funnel_name: `Addon_${props.flowType}` });
                }
                break;
            case 'NO_SUBSCRIBER_ERROR':
                gtag4({ event: `Addon_${props.flowType}_Step1_NoInternetProductsJoinButton`, step: '1', action: 'NoInternetProductsJoinButton', funnel_name: `Addon_${props.flowType}` });
                break;
        }
        buildUrlAndOpenSameWindow(url);
    }

    function handleOpenWhatsApp(e) {
        e.preventDefault();
        switch (props.errorDescription) {
            case 'SERVICE_EXISTS_ERROR':
                gtag4({ event: `Addon_${props.flowType}_Step2_AddonAlreadyExistWhatsappButton`, step: '2', action: 'AddonAlreadyExistWhatsappButton', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'SERVICE_NOT_SUPPORTED_ERROR':
                gtag4({ event: `Addon_${props.flowType}_Step2_AddonNotSupportedWhatsappButton`, step: '2', action: 'AddonNotSupportedWhatsappButton', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'EXISTS_ORDER_ERROR':
                gtag4({ event: `Addon_${props.flowType}_Step2_AddonOpenOrderWhatsappButton`, step: '2', action: 'AddonOpenOrderWhatsappButton', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'NOT_JET_CUSTOMER_ERROR':
                gtag4({ event: `Addon_${props.flowType}_Step2_CusNotAppearOnJetWhatsappButton`, step: '2', action: 'CusNotAppearOnJetWhatsappButton', funnel_name: `Addon_${props.flowType}` });
                break;
        }

        const whatsAppLink = `https://wa.me/${Config.whatsAppSelfCare}?force_isolation=true&text=`;
        let win = window.open(whatsAppLink, '_blank');
        win.focus();
    }

    function handleCallToService() {
        switch (props.errorDescription) {
            case 'SERVICE_EXISTS_ERROR':
                gtag4({ event: `Addon_${props.flowType}_Step2_AddonAlreadyExistRepButton`, step: '2', action: 'AddonAlreadyExistRepButton', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'SERVICE_NOT_SUPPORTED_ERROR':
                gtag4({ event: `Addon_${props.flowType}_Step2_AddonNotSupportedRepButton`, step: '2', action: 'AddonNotSupportedRepButton', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'EXISTS_ORDER_ERROR':
                gtag4({ event: `Addon_${props.flowType}_Step2_AddonOpenOrderRepButton`, step: '2', action: 'AddonOpenOrderRepButton', funnel_name: `Addon_${props.flowType}` });
                break;
            case 'NOT_JET_CUSTOMER_ERROR':
                gtag4({ event: `Addon_${props.flowType}_Step2_CusNotAppearOnJetRepButton`, step: '2', action: 'CusNotAppearOnJetRepButton', funnel_name: `Addon_${props.flowType}` });
                break;
        }

    }

    function handleCreateWhatsAppCall(event) {
        event.preventDefault();
        props.reportDWH({ actionType: 'Redirect to Service Message', status: 'Ongoing', messageText: 'Whatsapp Button Clicked' });
        gtag4({ event: `Addon_${props.flowType}_Step3_FailurePageGeneralWhatsappButton`, step: '3', action: 'FailurePageGeneralWhatsappButton', funnel_name: `Addon_${props.flowType}` });
        props.createWhatsAppCallAsync();
    }

    function handleLeadFormClick(event) {
        event.preventDefault();
        props.reportDWH({ actionType: 'Redirect to Service Message', status: 'Ongoing', messageText: 'Call me Button Clicked' });
        gtag4({ event: `Addon_${props.flowType}_Step3_FailurePageGeneralRepButton`, step: '3', action: 'FailurePageGeneralRepButton', funnel_name: `Addon_${props.flowType}` });
        props.createWorkOrderAsync({ isDisplayLoader: true });
    }

    function handleGoToLobby() {
        buildUrlAndOpenSameWindow(Config.selfCareInternetLink);
    }

};

const mapStateToProps = (state) => {
    return {
        errorPage: state.addonsBlock.errorPage,
        errorDescription: state.addonsBlock.errorDescription,
        flowType: state.addonsBlock.flowType,
        debtPaymentLink: state.addonsBlock.debtPaymentLink,
        updatePaymentLink: state.addonsBlock.updatePaymentLink,
        customerSpeed: state.addonsBlock.saleCatalog.internetSpeedList?.find(x => x.action == 'Existing'),
        joinServiceLink: state.addonsBlock.joinServiceLink,
        isDisplayWhatsApp: state.addonsBlock.isDisplayWhatsApp,
        isWhatsAppActive: state.addonsBlock.isWhatsAppActive,
        hasDebt: state.addonsBlock.subscriber.hasDebt,
        hasPaymentMethodIssue: state.addonsBlock.subscriber.hasPaymentMethodIssue,
        addon: state.addonsBlock.saleCatalog.addons?.find((x) => x.name == state.addonsBlock.addonId),
    };
};

const mapDispatchToProps = {
    reportDWH,
    createWorkOrderAsync,
    createWhatsAppCallAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
